// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".zone_pop_box{height:410px;padding:20px 0 0}.zone_pop_box .zone_key_word{color:#ff3973;font-weight:600}", ""]);
// Exports
module.exports = exports;
